export default {
  vehicleTitle: 'Pilih Kendaraan',
  vehicleQuest: 'Mau kirim dengan jenis kendaraan apa?',
  orderTitle: 'Check Pesanan',
  overviewTitle: 'Overview Semua Pesanan',
  vehicle: 'KENDARAAN',
  originLoc: 'LOKASI ASAL',
  originContact: 'KONTAK PENGIRIM',
  originName: 'Nama Pengirim (opsional)',
  originPhone: 'No. Telpon Pengirim (opsional)',
  destinationLoc: 'LOKASI TUJUAN',
  destinationContact: 'KONTAK PENERIMA',
  destinationName: 'Nama Penerima (opsional)',
  destinationPhone: 'No. Telpon Penerima (opsional)',
  addInfo: 'Tambahkan Informasi (opsional)',
  goods: 'BARANG YANG DIANTAR',
  goodsCategory: 'Kategori Barang',
  goodsSubCategory: 'Sub Kategori Barang',
  pickupDate: 'TANGGAL PENGAMBILAN BARANG',
  multiShipper: 'Multi Shipper',
  combineShipper: 'Gabungkan Dengan Shipper Lain',
  addOrder: 'Tambah Pesanan',
  sendOrder: 'Pesan Sekarang',
  duplicatOrder: 'Duplikasi Pesanan Ini',
  createContinueOrderButtonLabel: 'Buat Pesanan Lanjutan',
  confirmationDelete: 'Pesanan akan dihapus secara permanen, apakah anda yakin?',
  successDelete: 'Berhasil Menghapus Pesanan',
  selectOrderNo: 'Pilih No. Pesanan',
  fullLoad: 'Full Load',
  error: {
    emptyCategory: 'Harap Pilih Category',
    emptySubCategory: 'Harap Pilih Sub-Category',
    emptyOriginContact: 'Kontak pengirim harus diisi',
    emptyDestinationContact: 'Kontak penerima harus diisi',
    emptyReffShipperMerge: 'Harap Pilih Order dari Shipper Lain'
  }
}
